import { Flex } from '@mantine/core';
import * as React from 'react';
import { Outlet, useParams } from 'react-router-dom';

import NewsContent from '@/layouts/OrganizationLayout/NewsContent';
import { useDevices } from '@/utils/devices';

import s from './OrganizationNewsLayout.module.scss';

const OrganizationNewsPage: React.FC = () => {
  const { newsId } = useParams();
  const { isCompactViewport } = useDevices();
  const showList = isCompactViewport && !newsId;

  return (
    <Flex direction="column" className={s.root}>
      {showList && <NewsContent />}
      <Outlet />
    </Flex>
  );
};

export default OrganizationNewsPage;
